export default __webpack_public_path__ + "img/loading.b96c2931.gif";